import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxFileUploaderComponent } from 'devextreme-angular';
import { tap } from 'rxjs/operators';
import { Constants } from 'src/app/app.constants';
import { AuthService } from 'src/app/core/auth.service';
import { Dialog, DialogService } from 'src/app/core/dialog.service';
import { Image } from '../../base/base.models';
import { DocumentStorage, DocumentStorageType } from '../files.models';
import { FilesService } from '../files.service';

@Component({
    selector: 'app-files',
    templateUrl: './files.component.html',
    styleUrls: ['./files.component.scss']
})
export class FilesComponent implements OnInit {
    @ViewChild('fileUploader') fileUploader: DxFileUploaderComponent;
    @Input('images') images: any[] = [];
    @Input('single') single: boolean = false;
    @Input('canUpload') canUpload: boolean;
    @Input('code') code: string;
    @Input('type') type: DocumentStorageType | string;
    @Input('canDelete') canDelete: boolean = false;
    @Input('showPreview') showPreview: boolean = true;
    @Input('disabled') disabled: boolean = false;

    @Output() uploadFinishedEvent = new EventEmitter();
    @Output() deletedEvent = new EventEmitter();
    @Output() editEvent = new EventEmitter();

    public accepts: string = 'image/*';
    public name: string;
    public isNameModalVisible: boolean = false;
    public bucketBaseUrl = Constants.amazonS3Bucket;

    constructor(private filesService: FilesService, private dialogService: DialogService, private http: HttpClient, private authService: AuthService) {
    }

    ngOnInit(): void {
    }

    public onFileAdded(event) {
        let widget = event.component;
        const files: File[] = event.value;

        let file: DocumentStorage = new DocumentStorage();
        if (files.length > 0) {
            file.name = files[0].name;
            file.type = this.type;
            file.code = this.code;
            this.filesService.getUploadLink(file, (response) => {
                widget.option('uploadFile', this.filesService.fileUploadFunction(response.url));
                this.uploadFile();
            });
        }
    }

    uploadFile() {
        (<any>this.fileUploader.instance)._uploadFiles();
    }
    
    public onUploaded(event) {
        let imageUrl = `/${this.authService.companyId}/${this.type.toString().toLowerCase().replace(/_/g, '-')}/${this.code}/${event.file.name}`;
        let image: Image = new Image();
        image.isMain = false;
        image.path = imageUrl;
        this.uploadFinishedEvent.emit(image);
    }

    public deleteImage(image: any) {
        let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
            this.filesService.deleteFile(this.filesService.getImageFromPath(image.path || image), () => {
                this.deletedEvent.emit(image);
            });
        });

        this.dialogService.show(dialog);
    }

    public closeNameModal() {
        this.isNameModalVisible = false;
    }

    validateMain(image) {
        this.editEvent.emit(image);
    }

    // public uploadFile(){
    //     this.fileUploader.
    // }
}
